var _style, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBell = function SvgBell(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "bell_svg__Ebene_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1000 1000",
    ref: ref
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".bell_svg__bell0{fill:none;stroke:#000;stroke-width:.1953;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M484.6 846.8H75c-18.6 0-28.7-22.1-16.2-35.8 44.5-48.9 109.9-152.1 108-334.3-2.8-275.1 69.9-357.1 232.8-422.1 24.4-9.7 43.4-17.1 58-22.6-.4-1.8-.5-3.5-.5-5.4C457.1 12 469 .1 483.6.1c14.7 0 26.6 11.9 26.6 26.5 0 1.6-.1 3-.4 4.5 16 5.6 37.1 13.2 64.8 23.5 174.7 65 252.9 147 249.8 422.1-2 181.5 67.8 284.6 115.5 333.7 13.2 13.6 3.2 36.3-15.7 36.3H484.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M484.6 846.8H75c-18.6 0-28.7-22.1-16.2-35.8 44.5-48.9 109.9-152.1 108-334.3-2.8-275.1 69.9-357.1 232.8-422.1 24.4-9.7 43.4-17.1 58-22.6-.4-1.8-.5-3.5-.5-5.4C457.1 12 469 .1 483.6.1c14.7 0 26.6 11.9 26.6 26.5 0 1.6-.1 3-.4 4.5 16 5.6 37.1 13.2 64.8 23.5 174.7 65 252.9 147 249.8 422.1-2 181.5 67.8 284.6 115.5 333.7 13.2 13.6 3.2 36.3-15.7 36.3H484.6z",
    className: "bell_svg__bell0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M575 909.4c0 49.7-40.3 90-90 90s-90-40.3-90-90"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M575 909.4c0 49.7-40.3 90-90 90s-90-40.3-90-90",
    className: "bell_svg__bell0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBell);
export default ForwardRef;